module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "footer_in col-xs-12"
  }, [_c('div', {
    staticClass: "footer_left col-lg-3 col-md-3 col-sm-3 col-xs-4"
  }, [_c('a', {
    attrs: {
      "title": "Drishti",
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/images/dristi1.png"),
      "alt": "logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer_right col-lg-6 col-md-6 col-sm-6 col-xs-4"
  }, [_c('div', {
    staticClass: "footer_social"
  }, [_c('h6', [_vm._v("Follow us")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "target": "blank",
      "href": "https://www.facebook.com/drishtikathmandu/?ref=br_rs"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/social_2.png"),
      "alt": "social",
      "width": "35",
      "height": "34"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer_left col-lg-3 col-md-3 col-sm-3 col-xs-4"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "mailto:drishti.kathmandu@gmail.com"
    }
  }, [_vm._v("contact us")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "copy col-xs-12"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v("Copyright 2017 Drishti Kathmandu - All Rights Reserved")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a425ec2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterView.vue
// module id = 299
// module chunks = 1